import React, { Component } from 'react'
import LandingTheme from './LandingTheme'
import '../styles/ThemesContainer.css'
import ThemeLanding1 from '../images/Landing/theme-landing-1.jpg'
import ThemeLanding2 from '../images/Landing/theme-landing-2.jpg'
import ThemeLanding3 from '../images/Landing/theme-landing-3.jpg'
import ThemeLanding4 from '../images/Landing/theme-landing-4.jpg'
import ThemeLanding5 from '../images/Landing/theme-landing-5.jpg'
import ThemeLanding1Item1 from '../images/Landing/theme-landing-1-item-1.png'
import ThemeLanding1Item2 from '../images/Landing/theme-landing-1-item-2.png'
import ThemeLanding2Item1 from '../images/Landing/theme-landing-2-item-1.png'
import { injectIntl, defineMessages } from 'react-intl'

class ThemesContainer extends Component {
  render() {
    const {intl:{formatMessage}} = this.props

    return (
      <div className="themes-container">
        <LandingTheme
          position={1}
          title1={formatMessage(messages.laTitle1)}
          title2={formatMessage(messages.laTitle2)}
          baseline={formatMessage(messages.laBasline)}
          description={formatMessage(messages.laDescription)}
          picture={ThemeLanding1}
          item1={ThemeLanding1Item1}
          item2={ThemeLanding1Item2}
          path="/lost-asylum/"
          />
        <LandingTheme
          position={2}
          positionLeft
          title1={formatMessage(messages.vbnTitle1)}
          title2={formatMessage(messages.vbnTitle2)}
          baseline={formatMessage(messages.vbnBaseline)}
          description={formatMessage(messages.vbnDescription)}
          picture={ThemeLanding2}
          item2={ThemeLanding2Item1}
          path="/very-bad-night/"
          />
        <LandingTheme
          position={3}
          title1={formatMessage(messages.slaughterhouseTitle1)}
          baseline={formatMessage(messages.slaughterhouseBaseline)}
          description={formatMessage(messages.slaughterhouseDescription)}
          picture={ThemeLanding3}
          path="/abattoir/"
          />
        <LandingTheme
          position={4}
          positionLeft
          title1={formatMessage(messages.yakuzaTitle1)}
		  title2={formatMessage(messages.yakuzaTitle2)}
          baseline={formatMessage(messages.yakuzaBaseline)}
          description={formatMessage(messages.yakuzaDescription)}
          picture={ThemeLanding4}
          path="/yakuza/"
          />
        <LandingTheme
          position={5}
          title1={formatMessage(messages.tombeauTitle1)}
		  title2={formatMessage(messages.tombeauTitle2)}
          baseline={formatMessage(messages.tombeauBaseline)}
          description={formatMessage(messages.tombeauDescription)}
          picture={ThemeLanding5}
          path="/expedition-maudite/"
          />
        <div className="rectangle-left"></div>
      </div>
    );
  }
}

const messages = defineMessages({
  laTitle1: {
    id: 'themesContainer.laTitle1',
    defaultMessage: 'Lost'
  },
  laTitle2: {
    id: 'themesContainer.laTitle2',
    defaultMessage: 'Asylum'
  },
  laBasline: {
    id: 'themesContainer.laBasline',
    defaultMessage: 'échappez-vous avant de devenir fou'
  },
  laDescription: {
    id: 'themesContainer.laDescription',
    defaultMessage: "1952, un hôpital psychiatrique vient de fermer ses portes suite à un fait divers sanglant : un patient interné depuis de nombreuses années vient d’assassiner plusieurs médecins dans des circonstances encore inexpliquées. Depuis, on ne l’a jamais revu…"
  },
  vbnTitle1: {
    id: 'themesContainer.vbnTitle1',
    defaultMessage: 'Very'
  },
  vbnTitle2: {
    id: 'themesContainer.vbnTitle2',
    defaultMessage: 'Bad Night'
  },
  vbnBaseline: {
    id: 'themesContainer.vbnBaseline',
    defaultMessage: "une gueule de bois marathon"
  },
  vbnDescription: {
    id: 'themesContainer.vbnDescription',
    defaultMessage: "Après un lendemain de soirée difficile, vous vous réveillez dans un appartement inconnu. A en juger par l’état des lieux la soirée semble avoir été bien arrosée, mais hormis un énorme mal de crâne vous ne vous rappelez plus de grand chose."
  },
  slaughterhouseTitle1: {
    id: 'themesContainer.slaughterhouseTitle1',
    defaultMessage: "L'Abattoir"
  },
  slaughterhouseBaseline: {
    id: 'themesContainer.slaughterhouseBaseline',
    defaultMessage: "ça va trancher chérie"
  },
  slaughterhouseDescription: {
    id: 'themesContainer.slaughterhouseDescription',
    defaultMessage: "Cela fait depuis quelques semaines que la police mène des investigations sans succès sur de mystérieuses disparitions à Paris. Différentes sources vous amènent à enquêter sur l'abattoir de Voltaire, cet étrange lieu abandonné où on a retrouvé des sacs 'Cadaveroo'."
  },
  yakuzaTitle1: {
    id: 'themesContainer.yakuzaTitle1',
    defaultMessage: 'Mission'
  },
  yakuzaTitle2: {
    id: 'themesContainer.yakuzaTitle2',
    defaultMessage: 'Yakuza'
  },
  yakuzaBaseline: {
    id: 'themesContainer.yakuzaBaseline',
    defaultMessage: "une enquête policière à rebondissement"
  },
  yakuzaDescription: {
    id: 'themesContainer.yakuzaDescription',
    defaultMessage: "Kinechi Shonida, célèbre parrain de la mafia japonaise est introuvable. La police scientifique a besoin de la meilleure équipe pour retrouver sa trace."
  },
  tombeauTitle1: {
    id: 'themesContainer.tombeauTitle1',
    defaultMessage: "L'Expédition"
  },
  tombeauTitle2: {
    id: 'themesContainer.tombeauTitle2',
    defaultMessage: "Maudite"
  },
  tombeauBaseline: {
    id: 'themesContainer.tombeauBaseline',
    defaultMessage: "une aventure à la Indiana Jones"
  },
  tombeauDescription: {
    id: 'themesContainer.tombeauDescription',
    defaultMessage: "Vous êtes un groupe d’aventuriers parti à la recherche d’explorateurs perdus dans une vieille mine. Cette aventure vous amènera au travers de chemins tortueux dans des lieux où personne n’a mis les pieds depuis des milliers d’années."
  },
})

export default injectIntl(ThemesContainer)



// WEBPACK FOOTER //
// ./src/components/ThemesContainer.js